import * as pdfjsLib from 'pdfjs-dist';
// eslint-disable-next-line no-unused-vars
import pdfWowrker from "pdfjs-dist/build/pdf.worker.mjs?url";


export const extractText = async (file) => {
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

  let fullText = '';
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const textContent = await page.getTextContent();
    fullText += textContent.items.map(item => item.str).join(' ') + '\n';
  }
  return fullText;
};